<template>
  <div>
    <div class="filtering">
      <div
        class="toolbar__row"
      >
        <div
          class="search-filter"
        >
          <b-icon-search />
          <input
            v-model="searchValue"
            type="text"
            autocomplete="off"
            name="search-box"
            :placeholder="$t('orderMovementNumber')"
            @keydown.down.prevent="arrowDown"
            @keydown.up.prevent="arrowUp"
            @keydown.enter.prevent="selectHighlighted"
          >
          <b-icon-x-circle
            class="search-filter__clear"
            :class="{ 'search-filter__clear--active': searchValue !== '' }"
            @click="searchValue = ''"
          />
          <b-form-select
            v-model="toggleSearch"
            :options="searchFilterOptions"
          />
          <LoadingWrapperSpinner
            ref="scrollContainer"
            request-id="loadMovementOrderNumberLike"
            class="search-filter__options"
          >
            <div
              v-for="(result, index) in filteredResults"
              :key="index"
              ref="options"
              :class="{ 'is-active': index === arrowCounter }"
              class="search-filter__option"
              @click="selectResult(result)"
            >
              {{ displayResult(result) }}
            </div>
          </LoadingWrapperSpinner>
        </div>
      </div>
    </div>
    <div style="display:flex;gap:10px;">
      <div style="width: 80%;">
        <div
          class="not-toolbar"
          style="border-bottom:1px solid #EAE9EA;"
        >
          <div style="display:flex;flex-direction:column;width:100%;gap:5px;">
            <label style="font-weight:600;"> {{ $t('deliverStoreName') }}</label>
            <StoresDropdown
              :filiale="delivererStore"
              :all-included="'All'"
              style="width:40%"
              @updateFiliale="updateDeliverer"
            />
          </div>
          <div style="display:flex;gap:10px;width:100%">
            <div style="display:flex;flex-direction:column;gap:5px;width:100%">
              <label style="font-weight:600;"> {{ $t('State') }}</label>
              <vue-select
                v-model="stateValue"
                :options="stateValueOptions"
                label="text"
                :clearable="false"
                :reduce="(e) => e.value"
                :placeholder="$t('State')"
                style="width: 100%; min-width: 100%; max-width: 100%;"
                @input="updateStateValue"
              />
            </div>
            <div style="display:flex;flex-direction:column;gap:5px;">
              <label style="font-weight:600;"> {{ $t('deliverDate') }}</label>
              <date-picker
                v-model="deliverDate"
                value-type="format"
                format="YYYY-MM-DD"
                type="date"
                :placeholder="$t('SelectD')"
                @input="updateDatePicker"
              />
            </div>
          </div>
        </div>
        <div style="width: 100%;">
          <table
            class="team_table"
          >
            <thead>
              <tr>
                <th>
                  {{ $t('orderMovementNumber') }}
                </th>
                <th>
                  {{ $t('deliverStoreName') }}
                </th>
                <th>
                  {{ $t('State') }}
                </th>
                <th>
                  {{ $t('ResponsibleUser') }}
                </th>
                <th>
                  {{ $t('deliverDate') }}
                </th>
              </tr>
            </thead>
            <LoadingSpinnerTable
              :is-loading="isRequestLoading('loadStoreToStoreDeliverer')"
              :response-data="getStoreToStoreDeliverer?.items || []"
            >
              <tr
                v-for="(order, index) in getStoreToStoreDeliverer?.items"
                :key="index"
              >
                <td>
                  {{ order.orderMovementNumber }}
                </td>
                <td>
                  {{ order.deliverStoreName }}
                </td>
                <td>
                  {{ $t(order.state) }}
                </td>
                <td>
                  {{ order.fullUserName || $t('NoResponsibleUserFound') }}
                </td>
                <td>
                  {{ formatDate(order.deliverDate) }}
                </td>
              </tr>
            </LoadingSpinnerTable>
          </table>
          <div>
            <b-pagination
              v-model="pageNumberDeliverer"
              :total-rows="getStoreToStoreDeliverer?.totalItems"
              :per-page="pageSize"
              first-number
              last-number
              align="fill"
              size="md"
              prev-class="prev-item"
              next-class="next-item"
              class="mt-1 mb-0"
              @input="updatePageDeliverer"
            >
              <template #prev-text>
                <span class="previousOrNext"><b-icon-arrow-left />{{ $t('Previous') }}</span>
              </template>
              <template #next-text>
                <span class="previousOrNext">{{ $t('Next') }}<b-icon-arrow-right /></span>
              </template>
            </b-pagination>
          </div>
        </div>
      </div>
      <div style="width: 100%;">
        <div
          class="not-toolbar"
          style="border-bottom:1px solid #EAE9EA;"
        >
          <div style="display:flex;flex-direction:column;width:100%;gap:5px;">
            <label style="font-weight:600;"> {{ $t('receiverStoreName') }}</label>
            <vue-select
              v-model="receiverStore"
              :options="filteredStores"
              label="storeName"
              :clearable="false"
              style="width: 20%"
              @input="updateReceiver"
            />
          </div>
        </div>
        <div style="width: 100%;">
          <table
            class="team_table"
          >
            <thead>
              <tr>
                <th>
                  {{ $t('orderMovementNumber') }}
                </th>
                <th>
                  {{ $t('deliverStoreName') }}
                </th>
                <th>
                  {{ $t('receiverStoreName') }}
                </th>
                <th>
                  {{ $t('State') }}
                </th>
                <th>
                  {{ $t('ResponsibleUser') }}
                </th>
                <th>
                  {{ $t('deliverDate') }}
                </th>
                <th>
                  {{ $t('Actions') }}
                </th>
              </tr>
            </thead>
            <LoadingSpinnerTable
              :is-loading="isRequestLoading('loadStoreToStoreReceiver')"
              :response-data="getStoreToStoreReceiver?.items || []"
            >
              <tr
                v-for="(article, index) in getStoreToStoreReceiver?.items"
                :key="index"
                style="cursor:pointer"
              >
                <td>
                  {{ article.orderMovementNumber }}
                </td>
                <td>
                  {{ article.deliverStoreName }}
                </td>
                <td>
                  {{ article.receiverStoreName }}
                </td>
                <td>
                  {{ $t(article.state) }}
                </td>
                <td>
                  {{ article.fullUserName || $t('NoResponsibleUserFound') }}
                </td>
                <td>
                  {{ formatDate(article.deliverDate) }}
                </td>
                <td>
                  <b-dropdown
                    size="sm"
                    variant="link"
                    toggle-class="text-decoration-none"
                    no-caret
                    drop="left"
                  >
                    <template #button-content>
                      <b-icon-three-dots-vertical
                        class="h6"
                        style="color:black"
                      />
                    </template>
                    <b-dropdown-item>
                      <span
                        v-b-toggle.order-movement-details
                        class="dropdown-item-span"
                        @click="openOrderMovementDetails(article)"
                      >
                        <b-icon-eye />
                        <p>
                          {{ $t('OrderMovementDetails') }}
                        </p>
                      </span>
                    </b-dropdown-item>
                    <b-dropdown-item
                      :disabled="!canEditOrderMovement(article)"
                    >
                      <span
                        v-b-toggle.edit-order-movement-details
                        class="dropdown-item-span"
                        @click="openEditOrderMovementDetails(article)"
                      >
                        <b-icon-pencil />
                        <p>
                          {{ $t('Edit') }}
                        </p>
                      </span>
                    </b-dropdown-item>
                    <b-dropdown-item
                      @click="downloadPDF(article)"
                    >
                      <span
                        class="dropdown-item-span"
                      >
                        <img
                          style="cursor:pointer;"
                          src="../../assets/images/pdf-invoice-logo.svg"
                        >
                        <p>
                          {{ $t('DownloadPDF') }}
                        </p>
                      </span>
                    </b-dropdown-item>
                  </b-dropdown>
                </td>
              </tr>
            </LoadingSpinnerTable>
          </table>
          <div>
            <b-pagination
              v-model="pageNumberReceiver"
              :total-rows="getStoreToStoreReceiver?.totalItems"
              :per-page="pageSize"
              first-number
              last-number
              align="fill"
              size="md"
              prev-class="prev-item"
              next-class="next-item"
              class="mt-1 mb-0"
              @input="updatePageReceiver"
            >
              <template #prev-text>
                <span class="previousOrNext"><b-icon-arrow-left />{{ $t('Previous') }}</span>
              </template>
              <template #next-text>
                <span class="previousOrNext">{{ $t('Next') }}<b-icon-arrow-right /></span>
              </template>
            </b-pagination>
          </div>
        </div>
      </div>
      <div
        v-if="isSidebarOpen"
        class="backdrop"
      />
      <div
        v-if="isDownloadingPDF"
        style="width:100%"
        class="pdf-spinner-overlay"
      >
        <span class="loader" />
      </div>
      <OrderMovementDetails
        :clicked-order-movement-id="clickedOrderMovementId"
        :order-movement-state="orderMovementState"
        @onCancelToggle="onCancelToggle"
      />
      <EditOrderMovementDetails
        :clicked-order-movement-id="clickedOrderMovementId"
        :order-movement-state="orderMovementState"
        @updateMovementsListOnClose="updateMovementsListOnCloses"
        @onCancelToggle="onCancelToggle"
      />
    </div>
  </div>
</template>

<script>

import { mapActions, mapGetters } from 'vuex';
import moment from 'moment'
import DatePicker from 'vue2-datepicker';
import jsPDF from 'jspdf';
import {
  xharraIcon, iconLogo, qrCodeLogo, facebookLogo, instaLogo, mailLogo,
} from '../iconsImageUsers';
import StoresDropdown from '../StoresDropdown.vue';
import OrderMovementDetails from './modals/OrderMovementDetails.vue';
import EditOrderMovementDetails from './modals/EditOrderMovementDetails.vue';
import 'vue2-datepicker/index.css';
import 'jspdf-autotable';

export default {
  components: {
    StoresDropdown,
    DatePicker,
    OrderMovementDetails,
    EditOrderMovementDetails,
  },
  props: [],
  data() {
    return {
      isDownloadingPDF: false,
      isSidebarOpen: false,
      skipWatch: false,
      toggleSearch: 'OrderNumberMovement',
      searchFilterOptions: [
        {
          text: this.$t('orderMovementNumber'),
          value: 'OrderNumberMovement',
        },
      ],
      arrowCounter: -1,
      searchOrderMovement: '',
      searchOrderMovementId: null,
      delivererStore: { storeId: null, storeName: 'All', storeGLN: null },
      receiverStore: { storeId: null, storeName: 'All', storeGLN: null },
      pageNumberDeliverer: 1,
      pageNumberReceiver: 1,
      pageSize: 15,
      preventUpdate: false,
      deliverDate: moment().format('YYYY-MM-DD'),
      stateValue: 'PrepareInTransit',
      stateValueOptions: [
        { value: 'PrepareInTransit', text: this.$t('PrepareInTransit') },
        { value: 'InTransit', text: this.$t('InTransit') },
        { value: 'Accepted', text: this.$t('Accepted') },
      ],
      clickedOrderMovementId: null,
      orderMovementState: null,
    }
  },
  computed: {
    ...mapGetters([
      'getStoreToStoreDeliverer',
      'getStoreToStoreReceiver',
      'getAllStoresDropdown',
      'getMovementOrderNumberLike',
      'getLoggedInUser',
      'getOrderMovementDetails',
    ]),
    searchValue: {
      get() {
        if (this.toggleSearch === 'OrderNumberMovement') return this.searchOrderMovement;
        return '';
      },
      set(value) {
        if (this.toggleSearch === 'OrderNumberMovement') this.searchOrderMovement = value;
      },
    },
    filteredResults() {
      if (this.toggleSearch === 'OrderNumberMovement') return this.getMovementOrderNumberLike;
      return [];
    },
    filteredStores() {
      const filteredStores = this.getAllStoresDropdown.filter((store) => {
        return store.storeName !== 'all' && store.storeName !== 'unassigned';
      });

      const allOption = { storeId: null, storeName: 'All', storeGLN: null };
      return [allOption, ...filteredStores];
    },
  },
  watch: {
    searchOrderMovement(value) {
      if (this.skipWatch) {
        this.skipWatch = false;
        return;
      }

      if (this.timeoutId) {
        clearTimeout(this.timeoutId);
      }
      this.timeoutId = setTimeout(() => {
        if (value === '') {
          this.removeLists();
          this.updateOrderMovementsList()
        } else if (!this.enterPressed) {
          this.loadMovementOrderNumberLike({
            movementOrderNumberLike: value,
          });
        }
      }, 500);
    },
  },
  mounted() {

  },
  methods: {
    ...mapActions([
      'loadStoreToStoreDeliverer',
      'loadStoreToStoreReceiver',
      'loadMovementOrderNumberLike',
      'resetMovementOrderNumberLike',
      'loadOrderMovementDetails',
      'loadUsersByMultipleRoles',
      'loadRegularEmployeesId',
      'loadLocationsByStoreIdName',
    ]),
    canEditOrderMovement(article) {
      const userStoreId = this.getLoggedInUser?.storeId;

      if (article.state === 'PrepareInTransit') {
        return article.deliverStoreId === userStoreId;
      }

      if (article.state === 'InTransit') {
        return article.receiverStoreId === userStoreId;
      }

      return false;
    },
    updateMovementsListOnCloses() {
      this.preventUpdate = true;
      this.pageNumberDeliverer = 1
      this.pageNumberReceiver = 1
      this.loadStoreToStoreDeliverer({
        orderMovementState: this.stateValue,
        deliverStoreId: this.delivererStore?.storeId,
        deliverDate: this.deliverDate,
        orderMovementId: this.searchOrderMovementId,
        pageNumber: this.pageNumberDeliverer,
        pageSize: this.pageSize,
      })
      this.loadStoreToStoreReceiver({
        orderMovementState: this.stateValue,
        receiverStoreId: this.receiverStore?.storeId,
        deliverStoreId: this.delivererStore?.storeId,
        deliverDate: this.deliverDate,
        orderMovementId: this.searchOrderMovementId,
        pageNumber: this.pageNumberReceiver,
        pageSize: this.pageSize,
      })
      setTimeout(() => {
        this.preventUpdate = false;
      }, 100);
    },
    onCancelToggle() {
      this.isSidebarOpen = false
    },
    openOrderMovementDetails(value) {
      this.orderMovementState = value.state
      this.isSidebarOpen = true
      this.clickedOrderMovementId = value.orderMovementId
      this.loadOrderMovementDetails({
        orderMovementId: value.orderMovementId,
      })
      this.loadRegularEmployeesId({
        storeId: value.receiverStoreId,
      })
    },
    openEditOrderMovementDetails(value) {
      this.orderMovementState = value.state
      this.isSidebarOpen = true
      this.clickedOrderMovementId = value.orderMovementId
      this.loadOrderMovementDetails({
        orderMovementId: value.orderMovementId,
      })
      this.loadRegularEmployeesId({
        storeId: value.receiverStoreId,
      })
      this.loadLocationsByStoreIdName({
        storeId: value.receiverStoreId,
      })
    },
    searchByOrderMovement(value) {
      this.skipWatch = true;
      this.removeLists()
      this.searchOrderMovement = value.movementOrderNumber
      this.searchOrderMovementId = value.id
      this.loadStoreToStoreDeliverer({
        orderMovementState: this.stateValue,
        deliverStoreId: this.delivererStore?.storeId,
        orderMovementId: value.id,
        deliverDate: this.deliverDate,
        pageNumber: this.pageNumberDeliverer,
        pageSize: this.pageSize,
      })
      this.loadStoreToStoreReceiver({
        orderMovementState: this.stateValue,
        receiverStoreId: this.receiverStore?.storeId,
        deliverStoreId: this.delivererStore?.storeId,
        orderMovementId: value.id,
        deliverDate: this.deliverDate,
        pageNumber: this.pageNumberReceiver,
        pageSize: this.pageSize,
      })
    },
    removeLists() {
      this.arrowCounter = -1
      this.searchOrderMovementId = null
      this.resetMovementOrderNumberLike()
    },
    displayResult(result) {
      return result.movementOrderNumber;
    },
    selectResult(result) {
      if (this.toggleSearch === 'OrderNumberMovement') this.searchByOrderMovement(result);
    },
    arrowDown(ev) {
      ev.preventDefault()
      if (this.arrowCounter < this.filteredResults.length - 1) {
        this.arrowCounter++;
        this.fixScrolling();
      }
    },
    arrowUp(ev) {
      ev.preventDefault()
      if (this.arrowCounter > 0) {
        this.arrowCounter--;
        this.fixScrolling();
      }
    },
    selectHighlighted() {
      if (this.arrowCounter >= 0 && this.filteredResults.length > 0) {
        this.selectResult(this.filteredResults[this.arrowCounter]);
      }
    },
    fixScrolling() {
      this.$nextTick(() => {
        const options = this.$refs.options;
        const scrollContainer = this.$refs.scrollContainer?.$el;

        if (!options || !options[this.arrowCounter] || !scrollContainer) return;
        const selectedOption = options[this.arrowCounter];
        const optionHeight = selectedOption.clientHeight;

        const containerRect = scrollContainer.getBoundingClientRect();
        const selectedRect = selectedOption.getBoundingClientRect();

        if (selectedRect.bottom > containerRect.bottom) {
          scrollContainer.scrollTop += optionHeight;
        } else if (selectedRect.top < containerRect.top) {
          scrollContainer.scrollTop -= optionHeight;
        }
      });
    },
    updateStateValue(value) {
      this.preventUpdate = true;
      this.pageNumberDeliverer = 1;
      this.pageNumberReceiver = 1;
      this.loadStoreToStoreDeliverer({
        orderMovementState: value,
        deliverStoreId: this.delivererStore?.storeId,
        deliverDate: this.deliverDate,
        orderMovementId: this.searchOrderMovementId,
        pageNumber: this.pageNumberDeliverer,
        pageSize: this.pageSize,
      });

      this.loadStoreToStoreReceiver({
        orderMovementState: value,
        receiverStoreId: this.receiverStore?.storeId,
        deliverStoreId: this.delivererStore?.storeId,
        deliverDate: this.deliverDate,
        orderMovementId: this.searchOrderMovementId,
        pageNumber: this.pageNumberReceiver,
        pageSize: this.pageSize,
      });

      setTimeout(() => {
        this.preventUpdate = false;
      }, 100);
    },
    updateOrderMovementsList() {
      this.preventUpdate = true;
      this.pageNumberDeliverer = 1
      this.pageNumberReceiver = 1
      this.loadStoreToStoreDeliverer({
        orderMovementState: this.stateValue,
        deliverStoreId: this.delivererStore?.storeId,
        deliverDate: this.deliverDate,
        orderMovementId: this.searchOrderMovementId,
        pageNumber: this.pageNumberDeliverer,
        pageSize: this.pageSize,
      })
      this.loadStoreToStoreReceiver({
        orderMovementState: this.stateValue,
        receiverStoreId: this.receiverStore?.storeId,
        deliverStoreId: this.delivererStore?.storeId,
        deliverDate: this.deliverDate,
        orderMovementId: this.searchOrderMovementId,
        pageNumber: this.pageNumberReceiver,
        pageSize: this.pageSize,
      })
      setTimeout(() => {
        this.preventUpdate = false;
      }, 100);
    },
    formatDate(value) {
      return moment(value).format('YYYY-MM-DD')
    },
    updatePageDeliverer(value) {
      if (this.preventUpdate) return;
      this.loadStoreToStoreDeliverer({
        orderMovementState: this.stateValue,
        deliverStoreId: this.delivererStore?.storeId,
        deliverDate: this.deliverDate,
        orderMovementId: this.searchOrderMovementId,
        pageNumber: value,
        pageSize: this.pageSize,
      })
    },
    updatePageReceiver(value) {
      if (this.preventUpdate) return;
      this.loadStoreToStoreReceiver({
        orderMovementState: this.stateValue,
        receiverStoreId: this.receiverStore?.storeId,
        deliverStoreId: this.delivererStore?.storeId,
        deliverDate: this.deliverDate,
        orderMovementId: this.searchOrderMovementId,
        pageNumber: value,
        pageSize: this.pageSize,
      })
    },
    updateDatePicker(value) {
      this.preventUpdate = true;
      this.pageNumberDeliverer = 1
      this.pageNumberReceiver = 1
      this.loadStoreToStoreDeliverer({
        orderMovementState: this.stateValue,
        deliverStoreId: this.delivererStore?.storeId,
        deliverDate: value,
        orderMovementId: this.searchOrderMovementId,
        pageNumber: this.pageNumberDeliverer,
        pageSize: this.pageSize,
      })
      this.loadStoreToStoreReceiver({
        orderMovementState: this.stateValue,
        receiverStoreId: this.receiverStore?.storeId,
        deliverStoreId: this.delivererStore?.storeId,
        deliverDate: value,
        orderMovementId: this.searchOrderMovementId,
        pageNumber: this.pageNumberReceiver,
        pageSize: this.pageSize,
      })
      setTimeout(() => {
        this.preventUpdate = false;
      }, 100);
    },
    updateDeliverer(newFiliale) {
      this.preventUpdate = true;
      this.delivererStore = newFiliale;
      this.pageNumberDeliverer = 1
      this.pageNumberReceiver = 1
      this.loadStoreToStoreDeliverer({
        orderMovementState: this.stateValue,
        deliverStoreId: this.delivererStore?.storeId,
        deliverDate: this.deliverDate,
        orderMovementId: this.searchOrderMovementId,
        pageNumber: this.pageNumberDeliverer,
        pageSize: this.pageSize,
      })
      this.loadStoreToStoreReceiver({
        orderMovementState: this.stateValue,
        receiverStoreId: this.receiverStore?.storeId,
        deliverStoreId: this.delivererStore?.storeId,
        deliverDate: this.deliverDate,
        orderMovementId: this.searchOrderMovementId,
        pageNumber: this.pageNumberReceiver,
        pageSize: this.pageSize,
      })
      setTimeout(() => {
        this.preventUpdate = false;
      }, 100);
    },
    updateReceiver(newFiliale) {
      this.preventUpdate = true;
      this.receiverStore = newFiliale;
      this.pageNumberReceiver = 1
      this.loadStoreToStoreReceiver({
        orderMovementState: this.stateValue,
        receiverStoreId: this.receiverStore?.storeId,
        deliverStoreId: this.delivererStore?.storeId,
        deliverDate: this.deliverDate,
        orderMovementId: this.searchOrderMovementId,
        pageNumber: this.pageNumberReceiver,
        pageSize: this.pageSize,
      })
      setTimeout(() => {
        this.preventUpdate = false;
      }, 100);
    },
    async downloadPDF(value) {
      this.isDownloadingPDF = true;
      this.orderMovementState = value.state;

      try {
        await this.loadOrderMovementDetails({
          orderMovementId: value.orderMovementId,
        });

        const tableContent = this.generateLineItemsTablePDF(this.getOrderMovementDetails?.lineItemMovementPendingResponseDtos);
        const tableContent2 = this.generateProductsInStockTablePDF(this.getOrderMovementDetails?.productInStockMovementPendingResponseDtos);
        const pdfDocument = this.generatePDF(tableContent, tableContent2, xharraIcon, iconLogo, qrCodeLogo, facebookLogo, instaLogo, mailLogo, 800);

        pdfDocument.save(`${this.$t('orderMovementNumber')}: ${this.getOrderMovementDetails?.orderMovementNumber}-${moment().format('DD/MM/YYYY - hh:mm:s')}.pdf`);
      } catch (error) {
        console.error('Error downloading the data:', error);
      } finally {
        this.isDownloadingPDF = false;
      }
    },
    generateProductsInStockTablePDF(items) {
      const headers1 = [
        `${this.$t('No.')}`,
        `${this.$t('ArticleNumber')}`,
        `${this.$t('Barcode')}`,
        `${this.$t('Amount')}`,
        `${this.$t('State')}`,
      ];

      let body1 = [];

      if (!items || items.length === 0) {
        body1 = [[
          1,
          '—',
          '—',
          '—',
        ]];
      } else {
        body1 = items.map((item, index) => {
          return [
            index + 1,
            item.articleNumber,
            item.barcode || this.$t('NoBarcode'),
            item.amount || 0,
            this.$t(item.state) || this.$t('NotAccepted'),
          ];
        });
      }

      return {
        headers1,
        body1,
      };
    },
    generateLineItemsTablePDF(items) {
      const headers = [
        `${this.$t('No.')}`,
        `${this.$t('OrderNumber')}`,
        `${this.$t('ArticleNumber')}`,
        `${this.$t('State')}`,
      ];

      let body = [];

      if (!items || items.length === 0) {
        body = [[
          1,
          '—',
          '—',
        ]];
      } else {
        body = items.map((item, index) => {
          return [
            index + 1,
            item.orderNumber,
            item.articleNumber,
            this.$t(item.state) || this.$t('NotAccepted'),
          ];
        });
      }

      return {
        headers,
        body,
      };
    },
    generatePDF(tableContent, tableContent2, firstIcon, secondIcon, thirdIcon, fourthIcon, fifthIcon, sixthIcon, customWidth) {
      const { headers, body } = tableContent;
      const { headers1, body1 } = tableContent2;

      // eslint-disable-next-line new-cap
      const doc = new jsPDF({
        orientation: 'portrait',
        unit: 'pt',
        format: [750, 900],
      });

      // Set custom width after creating the doc instance
      doc.setProperties({
        format: [customWidth, doc.internal.pageSize.getHeight()],
      });

      const firstText = `${this.$t('State')} : ${this.$t(this.orderMovementState)}`;
      const firstTextX = 40;
      const firstTextY = 90;
      doc.setFontSize(15);
      doc.setFont('Helvetica', 'normal');
      doc.setTextColor(0, 0, 0);
      doc.text(firstText, firstTextX, firstTextY, { align: 'left' });

      const inlineGap = 35;

      const secondText = `${this.$t('deliverDate')} : ${moment(this.getOrderMovementDetails?.deliverDate).format('YYYY-MM-DD')}`;
      const secondTextX = firstTextX + doc.getTextWidth(firstText) + inlineGap;
      doc.text(secondText, secondTextX, firstTextY, { align: 'left' });

      const verticalGap = 25;

      const thirdText = `${this.$t('deliverStoreName')} : ${this.getOrderMovementDetails?.deliverStoreName}`;
      const thirdTextX = firstTextX;
      const thirdTextY = firstTextY + verticalGap;
      doc.text(thirdText, thirdTextX, thirdTextY, { align: 'left' });

      // Calculate width of thirdText
      const thirdTextWidth = doc.getTextWidth(thirdText);
      const receiverGap = 20;

      const fourthText = `${this.$t('receiverStoreName')} : ${this.getOrderMovementDetails?.receiverStoreName}`;
      // Place fourthText after thirdText + gap
      const fourthTextX = thirdTextX + thirdTextWidth + receiverGap;
      const fourthTextY = thirdTextY;
      doc.text(fourthText, fourthTextX, fourthTextY, { align: 'left' });

      const staticContent = () => {
        const title = `${this.$t('orderMovementNumber')} : ${this.getOrderMovementDetails?.orderMovementNumber}`;
        const titleY = 50;
        const titleX = 40;
        doc.setFontSize(30);
        doc.setFont('Helvetica', 'normal');
        doc.setTextColor(0, 0, 0);
        doc.text(title, titleX, titleY, { align: 'left' });

        const iconWidth = 150;
        const iconHeight = 100;
        const iconY = 5;
        const iconX = doc.internal.pageSize.getWidth() - 180;
        doc.addImage(firstIcon, 'PNG', iconX, iconY, iconWidth, iconHeight);

        // Location and Phone details
        const locations = [
          { name: 'PRISHTINË - Çagllavicë', name2: 'Rrethi Marigona Residence', phone: '+383 44 503 399' },
          { name: 'GJILAN', name2: 'Përball FSK-së', phone: '+383 44 991 994' },
          { name: 'PRIZREN', name2: 'Lubizhdë - Km. 1', phone: '+383 43 778 778' },
          { name: 'FERIZAJ - Magj.', name2: 'Ferizaj-Prishtinë - Km. 1', phone: '+383 49 640 940' },
          { name: 'PRISHTINË 2', name2: 'Rrethi Marigona Residence', phone: '+383 44 503 399' },
        ];

        const locationsY = doc.internal.pageSize.getHeight() - 90; // Start just above the footer
        const locationSpacing = 132; // Space between each location block

        const startXPosition = 40; // Starting position for the first location
        const endXPosition = startXPosition + (locations.length - 1) * locationSpacing + 132; // End X position based on number of locations

        // Loop through the locations array and display each one
        locations.forEach((location, index) => {
          const xPosition = 40 + index * locationSpacing; // Adjust X position for each location
          doc.setFontSize(8);
          doc.setTextColor(0, 0, 0); // Black color

          // Add the location icon
          const iconXPosition = xPosition - 25; // Position the icon just before the location name
          const iconYPosition = locationsY - 10; // Position the icon just above the location name
          doc.addImage(secondIcon, 'PNG', iconXPosition, iconYPosition, 28, 29); // Icon size 10x10 (adjust as needed)

          // Display the location name
          doc.text(location.name, xPosition, locationsY);

          doc.text(location.name2, xPosition, locationsY + 15);

          // Display the phone number below the location name
          doc.text(location.phone, xPosition, locationsY + 30); // Position phone number below the location name
        });

        // Add a line under the locations block, spanning the width of the locations
        doc.setDrawColor(0, 0, 0); // Black color for the line
        const lineY = locationsY + 40; // Position the line just below the last location's phone number
        doc.line(startXPosition, lineY, endXPosition, lineY); // Draw a line across the width of the locations

        // Show the three items in a row below the line
        const itemsXStart = 40; // Starting position for the row of items
        const itemsY = lineY + 3; // Y-position for the items row

        const items = [
          { icon: fourthIcon, text: 'NOTAbrillantOfficial' },
          { icon: fifthIcon, text: 'nota.brillant' },
          { icon: sixthIcon, text: 'info@notabrillantofficial.com' },
        ];

        // Space between each item in the row
        const itemSpacing = 150; // Adjust this for the space between icons and text

        items.forEach((item, index) => {
          const xPosition = itemsXStart + index * itemSpacing; // Calculate horizontal position for each item

          // Add the icon and text next to each other
          doc.addImage(item.icon, 'PNG', xPosition, itemsY, 20, 20); // Icon position and size
          doc.setFontSize(12);
          doc.text(item.text, xPosition + 25, itemsY + 15); // Position text next to the icon (adjust the X offset if needed)
        });

        // QR code section
        const qrCodeText = 'Blej online';
        const qrCodeTextWidth = doc.getTextWidth(qrCodeText);
        const qrCodeTextX = 680 + (45 - qrCodeTextWidth) / 2; // Center the text above the QR code
        const qrCodeTextY = doc.internal.pageSize.getHeight() - 60; // Adjust the Y position to place text above the QR code
        doc.setFontSize(10);
        doc.setTextColor(0, 0, 0); // Black color
        doc.text(qrCodeText, qrCodeTextX, qrCodeTextY);

        // Add the QR code image
        doc.addImage(thirdIcon, 'PNG', 680, doc.internal.pageSize.getHeight() - 50, 45, 45);

        // Footer section
        const footerText = 'Powered by DigIT';
        const footerTextWidth = doc.getTextWidth(footerText);
        const centerX = (doc.internal.pageSize.getWidth() - footerTextWidth) / 2;
        const footerY = doc.internal.pageSize.getHeight() - 10;

        doc.setFontSize(10);
        doc.setTextColor(160, 160, 160);
        doc.text(footerText, centerX, footerY);
      };

      const tableLeftMargin = 40;

      // Add header "Orders" before the first table
      doc.setFontSize(16); // Adjust the font size for the header
      doc.text(this.$t('Orders'), tableLeftMargin, 150);
      doc.autoTable({
        startY: 160,
        head: [headers],
        body,
        headStyles: {
          fillColor: [249, 249, 249],
          textColor: [96, 96, 96],
          lineColor: [181, 181, 181],
          lineWidth: 0.1,
          halign: 'left',
        },
        bodyStyles: {
          textColor: [0, 0, 0],
          lineWidth: 0.1,
        },
        pageBreak: 'auto',
        columnStyles: {
          0: { columnWidth: doc.internal.pageSize.getWidth() / 20, halign: 'left', fillColor: [255, 255, 255] },
          1: { columnWidth: doc.internal.pageSize.getWidth() / 3.5, halign: 'left', fillColor: [255, 255, 255] },
          2: { columnWidth: doc.internal.pageSize.getWidth() / 3.5, halign: 'left', fillColor: [255, 255, 255] },
          3: { columnWidth: doc.internal.pageSize.getWidth() / 3.5, halign: 'left', fillColor: [255, 255, 255] },
        },
        afterPageContent: staticContent,
      });

      const firstTableEndY = doc.lastAutoTable.finalY;

      // Add header "Products" before the second table
      doc.setFontSize(16); // Adjust font size for the second header
      doc.text(this.$t('Products'), tableLeftMargin, firstTableEndY + 20);

      const secondTableStartY = firstTableEndY + 30; // Where the second table will start

      // Check available space for the second table
      const availableSpace = doc.internal.pageSize.getHeight() - secondTableStartY - 20; // 20 for margin

      // If the available space is less than the second table's height, add a page break
      if (availableSpace < 150) { // Assuming the second table is around 150pt high
        doc.addPage();
        doc.setFontSize(16); // Header for the second table again
        doc.text(this.$t('Products'), tableLeftMargin, 40); // Start the second table header at the top of the page
      }

      // Start the second table at Y position 250 if it's on the second page
      const secondTableStartYPosition = doc.internal.getNumberOfPages() > 1 ? 250 : secondTableStartY;

      doc.autoTable({
        startY: secondTableStartYPosition,
        head: [headers1],
        body: body1,
        headStyles: {
          fillColor: [249, 249, 249],
          textColor: [96, 96, 96],
          lineColor: [181, 181, 181],
          lineWidth: 0.1,
          halign: 'left',
        },
        bodyStyles: {
          textColor: [0, 0, 0],
          lineWidth: 0.1,
        },
        pageBreak: 'auto',
        columnStyles: {
          0: { columnWidth: doc.internal.pageSize.getWidth() / 20, halign: 'left', fillColor: [255, 255, 255] },
          1: { columnWidth: doc.internal.pageSize.getWidth() / 4.5, halign: 'left', fillColor: [255, 255, 255] },
          2: { columnWidth: doc.internal.pageSize.getWidth() / 4.5, halign: 'left', fillColor: [255, 255, 255] },
          3: { columnWidth: doc.internal.pageSize.getWidth() / 4.5, halign: 'left', fillColor: [255, 255, 255] },
          4: { columnWidth: doc.internal.pageSize.getWidth() / 4.5, halign: 'left', fillColor: [255, 255, 255] },
        },
        afterPageContent: staticContent,
      });

      // Save the PDF
      return doc;
    },
  },
}
</script>

    <style>
    .dropdown-menu.show {
    left: -100px !important;
}
      .disabled {
  cursor: not-allowed !important;
}
.dropdown-item-new {
    display: block;
    width: 100%;
     padding: 0px !important;
    clear: both;
    font-weight: 400;
    color: var(--bs-dropdown-link-color);
    text-align: inherit;
    text-decoration: none;
    white-space: nowrap;
    background-color: transparent;
    border: 0;
    border-radius: var(--bs-dropdown-item-border-radius, 0);
}
.dropdown-item-span {
  display:flex;
  gap:5px;
}
    </style>
